const RESIZER = {
    title: 'Image Resizer Online - Resize Image Free without Losing Quality',
    canonical: 'https://retoucher.online/image-resizer',
    description: 'Easily resize image with online Photo Resizer in 3 clicks: • Upload one or multiple images • Choose the output size • Download in bulk using ready presets',
    keywords: 'image resizer, resize image, photo resizer'
}

const ROTATE = {
    title: 'Image Rotator - Rotate Image Online - Free and Fast',
    canonical: 'https://retoucher.online/image-rotator',
    description: 'Free Image Rotator keeps the original quality of your photo. Rotate pictures to any angle (90, 180, 270 clockwise) in bulk in seconds. All formats are supported.',
    keywords: 'image rotator, rotate image'
}

const FLIP = {
    title: '[Free] Flip Image & Mirror Photo - Image Flipper Online',
    canonical: 'https://retoucher.online/image-flipper',
    description: 'Use free online Image Flipper to flip image horizontally or vertically in 3 secs. Mirror photos and pictures in bulk on any device in any format: JPG, PNG, BMP.',
    keywords: 'flip image, image flipper, image flip'
}

const CROPPER = {
    title: 'Image cropper - Crop Image Online - Free',
    canonical: 'https://retoucher.online/image-cropper',
    description: 'Free Image Cropper lets you crop any image online. Try photo cropper to prepare your images for any purpose and social media (Instagram, Linkedin) in bulk.',
    keywords: 'image cropper, crop image, crop image online, image crop'
}

export default function getContantPage(service: string) {
    switch (service) {
        case 'resizer': return RESIZER;
        case 'rotator': return ROTATE;
        case 'flipper': return FLIP;
        case 'cropper': return CROPPER;
        default:
            return {
                title: ``,
                canonical: ``,
                description: ``,
                keywords: ``
            };
    }
}